import type { IztCourse, IztLayoutSection } from '../../courses/courses';
import { bareIzteachClient } from '../clients';
import { retryColdStart } from '../core/coldStart';
import type { QueryParams } from '../core/params';
import { libraryVendorId } from '../session';

// IZTeach online-course (public, bare client, no token); vendorId is content-tenant filter sent to every call

function get<T>(path: string, params: QueryParams): Promise<T> {
  // the online-course Lambda 500s its first calls after a cold start
  return retryColdStart(() => bareIzteachClient('online').get(path, { params: { ...params, vendorId: libraryVendorId() } }).then((res) => res.data as T));
}

export const CourseRepository = {
  list: (query: QueryParams) => get<unknown>('/course', query).then((rows) => (Array.isArray(rows) ? rows as IztCourse[] : [])),

  count: (filter: QueryParams) => get<unknown>('/course/count', filter).then((value) => Number(value) || 0),

  // ids_in is fetchMany on the server: every id, no paging, no archive filter
  byIds: (ids: string[]) => get<unknown>('/course', { ids_in: ids }).then((rows) => (Array.isArray(rows) ? rows as IztCourse[] : [])),

  fetchOne: (id: string) => get<IztCourse | null>(`/course/${encodeURIComponent(id)}`, {}),

  // chapters with their units, and sub-sections when the course has them (course/services/fetch-layout.js)
  layout: (id: string) => get<unknown>(`/course/layout/${encodeURIComponent(id)}`, {}).then((rows) => (Array.isArray(rows) ? rows as IztLayoutSection[] : [])),
};

export default CourseRepository;
